// src/store/contactSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/setup/initialState.serviceLevel.data';
import {
  createServiceLevel as createServiceLevelAPI,
  fetchServiceLevelUpdated as fetchServiceLevelUpdatedAPI, //New Updated Post API to Search
  updateServiceLevel as updateServiceLevelAPI,
  deactivateAndActivateServiceLevel as deactivateAndActivateServiceLevelAPI,
} from '../../../apis/serviceLevelAPI';
import { ACTIONS_SERICE_LEVEL } from '../../../constants/actionCreator';
import {
  CHECK_BOX_VALUE,
  GRID_ROW_ID,
  handlePending,
  handleRejection,
} from '../../../constants';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import {
  replaceElements,
  convertTimeTo12HourFormat,
} from '../../../utils/common';

// API Call Functions
export const createServiceLevel = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.CREATE,
  createServiceLevelAPI
);

export const fetchNameContains = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.FETCH,
  fetchServiceLevelUpdatedAPI
);

export const deactivateAndActivateServiceLevel = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.SERVICE_LEVEL_STATUS,
  deactivateAndActivateServiceLevelAPI
);

export const updateServiceLevel = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.UPDATE,
  updateServiceLevelAPI
);

export const fetchSeachedData = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.SEARCHED,
  fetchServiceLevelUpdatedAPI
);

// Create a function to find a record by ID in the filtered data
const handleUpdateGridData = (data, updatedRecords) => {
  const newData = data?.map((item) => {
    if (item.service_Level_Id === updatedRecords.service_Level_Id) {
      return updatedRecords;
    }
    return item;
  });
  return newData;
};

const serviceLevelSlice = createSlice({
  name: 'serviceLevel',
  initialState,
  reducers: {
    setFormFields: (state, action) => {
      state.serviceLevelForm[action.payload.name] = action?.payload?.value;
    },
    handleUpdateForm: (state, action) => {
      const { data, serviceResponseTypeData } = action?.payload;
      const {
        name,
        description,
        service_Level_Type_Id,
        service_Response_Type_Id,
        service_Location_Id,
        work_Order_Type_Id,
        has_Addon_Service_Flag,
        service_Offering_Addon_Id,
        ship_Method_Id,
        days_Supported,
        hours_Supported,
        ordered_By_Time,
        on_Site_Compliance_Time,
        active_Flag,
        available_For_Contract,
        premium_Flag,
        available_On_Contract_Flag,
        exclude_Holidays,
        exclude_Weekends,
        service_Level_Id,
      } = data[0] || [];
      const service_Response_data = serviceResponseTypeData?.filter(
        (item) => item.service_Response_Type_Id === service_Response_Type_Id
      );
      state.serviceLevelForm = {
        name,
        description,
        service_Level_Type_Id,
        service_Response_Type_Id:
          service_Response_data[0].service_Response_Type_Id,
        service_Location_Id,
        work_Order_Type_Id,
        has_Addon_Service_Flag,
        service_Offering_Addon_Id,
        ship_Method_Id,
        days_Supported,
        hours_Supported,
        ordered_By_Time: convertTimeTo12HourFormat(`${ordered_By_Time}:00`),
        on_Site_Compliance_Time: convertTimeTo12HourFormat(
          `${on_Site_Compliance_Time}:00`
        ),
        active_Flag: active_Flag
          ? active_Flag.toLowerCase() === CHECK_BOX_VALUE.yes
          : false,
        available_For_Contract: available_For_Contract
          ? available_For_Contract.toLowerCase() === CHECK_BOX_VALUE.yes
          : false,
        premium_Flag: premium_Flag
          ? premium_Flag.toLowerCase() === CHECK_BOX_VALUE.yes
          : false,
        available_On_Contract_Flag: available_On_Contract_Flag
          ? available_On_Contract_Flag.toLowerCase() === CHECK_BOX_VALUE.yes
          : false,
        exclude_Holidays: exclude_Holidays
          ? exclude_Holidays.toLowerCase() === CHECK_BOX_VALUE.yes
          : false,
        exclude_Weekends: exclude_Weekends
          ? exclude_Weekends.toLowerCase() === CHECK_BOX_VALUE.yes
          : false,
        service_Level_Id: service_Level_Id,
      };
      state.serviceResponseTypeObj = service_Response_data[0];
    },
    handleSearchTerm: (state, action) => {
      state.isNeedToCallSearchAPI = true;
      state.searchTerm = action?.payload;
      if (action?.payload !== null) {
        state.selectedSearchTerm = null;
      }
    },
    handleSearchTermObj: (state, action) => {
      state.isNeedToCallSearchAPI = false;
      state.selectedSearchTerm = action?.payload;
    },
    handleActiveCheckbox: (state, action) => {
      state.isActiveCheckbox = action?.payload;
    },
    handlePremiumCheckbox: (state, action) => {
      state.isPremiumCheckbox = action?.payload;
    },
    handleReset: () => initialState,
    setFilteredData: (state, action) => {
      state.filteredData = action?.payload;
    },
    setSelectedGridRowsData: (state, action) => {
      if (action?.payload.length > 0) {
        state.gridRowSelectedData = action?.payload;
        state.gridRowSelectedCount = action?.payload?.length || 0;

        state.slArray[state.currentPage ? state.currentPage : 1] =
          action?.payload;
      }
    },
    handleResetForm: (state) => {
      state.serviceLevelForm = { ...initialState.serviceLevelForm };
      state.serviceResponseTypeObj = initialState.serviceResponseTypeObj;
    },
    setValidationError: (state, action) => {
      state.errors = action?.payload;
    },
    setAPISuccessResponse: (state, action) => {
      state.apiSuccessResponse = {
        ...state.apiSuccessResponse,
        ...action.payload,
      };
    },
    handleActivateFlag: (state, action) => {
      state.isActivate = action?.payload;
    },
    hanldleServiceResponseType: (state, action) => {
      const data = action?.payload;
      state.serviceResponseTypeObj = data?.target?.value;
      state.serviceLevelForm.service_Response_Type_Id =
        data?.target?.value?.service_Response_Type_Id;
      let onSiteByTiem = convertTimeTo12HourFormat(
        `${data?.target?.value?.on_Site_Compliance_Time}:00`
      );
      let orderedByTime = convertTimeTo12HourFormat(
        `${data?.target?.value?.ordered_By_Time}:00`
      );
      state.serviceLevelForm.on_Site_Compliance_Time = onSiteByTiem;
      state.serviceLevelForm.ordered_By_Time = orderedByTime;
      state.errors = { ...state.errors, [data.target.name]: null };
    },
    handleOnsiteComplianceTime: (state, action) => {
      state.serviceLevelForm.on_Site_Compliance_Time = action?.payload;
    },
    handleOrderedByTime: (state, action) => {
      state.serviceLevelForm.ordered_By_Time = action?.payload;
    },
    handleslArray: (state) => {
      state.slArray = [];
    },
    handleCurrentPage: (state, action) => {
      state.currentPage = action?.payload;
    },
    handleisResetsl: (state, action) => {
      state.isResetSl = action?.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createServiceLevel.pending, handlePending)
      .addCase(createServiceLevel.fulfilled, (state) => {
        state.loading = false;
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          create: true,
        };
      })
      .addCase(createServiceLevel.rejected, handleRejection)

      .addCase(fetchNameContains.pending, (state) => {
        state.loading = true;
        state.searchContainesData = [];
      })
      .addCase(fetchNameContains.fulfilled, (state, action) => {
        state.loading = false;
        state.searchContainesData = action?.payload?.serviceLevel || [];
      })
      .addCase(fetchNameContains.rejected, (state) => {
        state.loading = false;
        state.searchContainesData = [];
      })

      .addCase(updateServiceLevel.pending, handlePending)
      .addCase(updateServiceLevel.fulfilled, (state, action) => {
        state.loading = false;
        const updatedRecords = action.payload;
        const filterData = [...state.filteredData];
        const initialData = [...state.searchData];
        const updatedFilterData = handleUpdateGridData(
          filterData,
          updatedRecords
        );
        const updatedSearchData = handleUpdateGridData(
          initialData,
          updatedRecords
        );
        state.filteredData = updatedFilterData;
        state.searchData = updatedSearchData;
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          update: true,
        };
      })
      .addCase(updateServiceLevel.rejected, handleRejection)

      .addCase(deactivateAndActivateServiceLevel.pending, (state) => {
        if (state.isActivate) {
          state.isActiveLoading = true;
        } else {
          state.isDeactiveLoading = true;
        }
      })
      .addCase(deactivateAndActivateServiceLevel.fulfilled, (state, action) => {
        state.loading = false;
        const updatedRecords = action.payload;
        const filterData = [...state.filteredData];
        const initialData = [...state.searchData];
        const updatedFilterData = replaceElements(
          filterData,
          updatedRecords,
          GRID_ROW_ID.serviceLevel,
          'premium_Flag'
        );
        const updatedSearchData = replaceElements(
          initialData,
          updatedRecords,
          GRID_ROW_ID.serviceLevel,
          'premium_Flag'
        );
        state.filteredData = updatedFilterData;
        state.searchData = updatedSearchData;
        if (state.isActivate) {
          state.apiSuccessResponse = {
            ...initialState.apiSuccessResponse,
            activate: true,
          };
          state.isActiveLoading = false;
        } else {
          state.apiSuccessResponse = {
            ...initialState.apiSuccessResponse,
            deactivate: true,
          };
          state.isDeactiveLoading = false;
        }
      })
      .addCase(deactivateAndActivateServiceLevel.rejected, (state) => {
        state.loading = false;
        state.isActiveLoading = false;
        state.isDeactiveLoading = false;
      })

      .addCase(fetchSeachedData.pending, (state) => {
        state.loading = true;
        state.isSearchedDataFetching = null;
        state.searchData = [];
        state.filteredData = [];
      })
      .addCase(fetchSeachedData.fulfilled, (state, action) => {
        state.loading = false;
        state.isSearchedDataFetching = action?.payload?.totalRecords > 0;
        state.searchData = action?.payload?.serviceLevel || [];
        state.serviceLevelTotalRecords = action?.payload
          ? action.payload?.totalRecords
          : 0;
      })
      .addCase(fetchSeachedData.rejected, (state) => {
        state.loading = false;
        state.isSearchedDataFetching = true;
        state.searchData = [];
      });
  },
});

export const {
  setFormFields,
  handleUpdateForm,
  handleSearchTerm,
  handleActiveCheckbox,
  handlePremiumCheckbox,
  handleReset,
  setFilteredData,
  setSelectedGridRowsData,
  handleResetForm,
  setValidationError,
  setAPISuccessResponse,
  handleActivateFlag,
  handleSearchTermObj,
  hanldleServiceResponseType,
  handleOnsiteComplianceTime,
  handleOrderedByTime,
  handleslArray,
  handleCurrentPage,
  handleisResetsl
} = serviceLevelSlice.actions;

export default serviceLevelSlice.reducer;
